module.exports = __webpack_public_path__ + "media/images/thumbs/pathophys/1z2vrlzP4wcR5i62SGRdBn-5f0b044b7132a4cd4979bb9a1acadc46.jpg";